export default function getResource(label) {
    const resources = {
        joinNow: 'S’inscrire',
        createAccount: 'Créer un compte',
        signIn: 'Ouvrir une session',
        signUpInStore: 'Vous pouvez également vous inscrire en magasin! Il suffit de montrer la recommandation de votre ami pour obtenir 10 % de réduction sur votre achat de 25 $ ou plus.'
    };

    return resources[label];
}
